import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { motion, AnimatePresence } from 'framer-motion'
import get from 'lodash/get'
import { useAppState } from '../Layout'
import { useScrollFreeze } from '@hooks'
import { Link } from '@elements'
import { htmlDecode } from '@utils'

export const SlidingMenu = () => {
  const { isMenuOpen } = useAppState()
  return <AnimatePresence>{isMenuOpen && <Navigation />}</AnimatePresence>
}

const Navigation = () => {
  const data = useStaticQuery(graphql`
    query {
      ...MainNav
      site {
        siteMetadata {
          API_URL
        }
      }
    }
  `)

  const { toggleMenu } = useAppState()
  useScrollFreeze()

  // safely get the main menu or an empty array
  const mainMenu = get(data, 'mainNav.menuItems.edges', []).filter(
    ({ node }) => !node.parentId
  )
  const API_URL = get(data, 'site.siteMetadata.API_URL', [])

  return (
    <motion.div
      key="MobileNavigation"
      initial={{ x: `100%`, opacity: 0 }}
      animate={{ x: `0%`, opacity: 1 }}
      exit={{ x: `100%`, opacity: 0 }}
      transition={{ ease: 'easeInOut' }}
      className="fixed inset-0 z-40 text-gray-400 bg-gray-400 bg-opacity-50"
    >
      <nav className="absolute inset-y-0 right-0 z-50 flex flex-col w-full max-w-xl overflow-scroll bg-white shadow">
        <div className="flex justify-end">
          <button
            onClick={toggleMenu}
            className="px-5 py-2 text-5xl leading-none"
          >
            &times;
          </button>
        </div>
        <div className="flex flex-col h-full mx-16 mb-16">
          {mainMenu.map(({ node }, idx, arr) => {
            const isPenultimate = idx === arr.length - 2
            const isLast = idx === arr.length - 1
            return (
              <TopLevelNavItem
                key={node.url}
                API_URL={API_URL}
                node={node}
                to={node.url.replace(API_URL, '')}
                isLast={isLast}
                isPenultimate={isPenultimate}
              />
            )
          })}
        </div>
      </nav>
    </motion.div>
  )
}

function TopLevelNavItem({ node, isPenultimate, isLast, to, API_URL }) {
  const [isOpen, setIsOpen] = useState(false)

  const hasChildren = node.childItems && node.childItems.edges.length > 0

  if (!hasChildren) {
    return (
      <div
        className={`w-full flex flex-col ${isPenultimate ? 'flex-grow' : ''}`}
      >
        <Link
          to={to}
          className={`relative py-4 text-xl cursor-pointer font-bold font-sans uppercase flex  ${
            isLast ? '' : 'border-b'
          } ${
            isLast
              ? 'font-sans pt-3 pb-2 text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow justify-center'
              : 'justify-between'
          }`}
          // activeClassName="font-bold bg-gray-100 text-gray-400"
        >
          {node.label}
        </Link>
      </div>
    )
  }

  return (
    <div className={`w-full flex flex-col ${isPenultimate ? 'flex-grow' : ''}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`relative py-4 text-xl cursor-pointer  font-bold font-sans uppercase flex justify-between items-center ${
          isLast ? '' : 'border-b'
        } ${isLast ? 'btn secondary text-center' : ''}`}
      >
        <span>{node.label}</span>
        <span>
          <svg
            width="11"
            height="6"
            viewBox="0 0 21 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="1.74219"
              width="2.26538"
              height="14.1586"
              transform="rotate(-45 0 1.74219)"
              fill="#454545"
            />
            <rect
              x="18.6499"
              width="2.26538"
              height="14.1586"
              transform="rotate(45 18.6499 0)"
              fill="#454545"
            />
          </svg>
        </span>
      </button>
      <motion.div
        className="flex flex-col"
        variants={{
          open: { opacity: 1, height: 'auto' },
          closed: { opacity: 0, height: 0, overflow: 'hidden' },
        }}
        initial={'closed'}
        animate={isOpen ? 'open' : 'closed'}
      >
        {node.childItems.edges.map(({ node }) => {
          return (
            <Link
              key={node.label}
              to={node.url.replace(API_URL, '')}
              className="px-4 py-3 font-sans font-bold uppercase"
            >
              {htmlDecode(node.label)}
            </Link>
          )
        })}
      </motion.div>
    </div>
  )
}
